module.exports = __webpack_public_path__ + "static/media/HCMM157.af68fd8c.jpg";